<template>
    <div class="result overflow-auto" ref="p2">
        <div v-if="showLocationError">
            <b-container fluid class="p-4 bg-light">
                <b-row align-h="center">
                    <b-col>
                        <b-card
                            title="Please enable location access"
                            style="max-width: 20rem;"
                            class="mb-2"
                        >
                            <b-card-text>
                            Sorry, we are unable to show you results due to missing GPS permission. Check this instruction to reenable it.
                            </b-card-text>

                            <a target="_blank" href="https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=en"><b-button>How to enable geolocation</b-button></a>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center;" class="my-4 mx-4"> 
            <div class="h4 font-weight-bold mb-0">
                <!-- maybe query param is not the right variable -->
                <div v-if="place_list.length > 0">
                    Browsing {{this.search_param.location}} businesses
                </div>
                <div v-else>
                    <!-- add more content, like improve your wording, and add a card for adding a new business -->
                    No results for {{this.search_param.location}}
                </div>
            </div>
            <div>
                <b-input-group prepend="Sort">
                    <b-dropdown id="dropdown-1" :text="sortSelectedText" variant="outline-danger">
                        <b-dropdown-item @click="sortSelected('recommended')">Recommended</b-dropdown-item>
                        <b-dropdown-item @click="sortSelected('highest-rated')">Highest Rated</b-dropdown-item>
                        <b-dropdown-item @click="sortSelected('most-reviewed')">Most Reviewed</b-dropdown-item>
                    </b-dropdown>
                </b-input-group>
            </div>
        </div>
        <SearchItem 
            :ref="'searchItem-' + itemObjKey"
            v-for="(place, itemObjKey) in place_list" :key="place.id"
            :number="place.localNumber"
            :name="place.name"
            :imageUrl="place.imageUrl"
            :starRating="place.averageRating"
            :priceRating="place.price"
            :reviewCount="place.numberOfRatings"
            :categories="place.categories"
            secondText="Kashmir closed in Ermita some time ago, and all their staff transferred to this location to ensure their legacy of wonderful Indian cuisine continues."
            :phoneAndAddr="{phone: place.phone, addr1: place.locationAddress1, addr2: place.locationAddress2, city: place.locationCity }"
            @mouseover.native="onMouseOver(place)"
            @mouseleave.native="onMouseLeave"
            @click.native="clicked(place)"
        >
        </SearchItem>
        <b-pagination
            v-if="showPagination"
            v-model="place_currentPage"
            :total-rows="place_totalRows"
            :per-page="place_perPage"
            :hide-ellipsis=true
            limit=7
        ></b-pagination>
    </div>
</template>

<style scoped>
.result {
    /* background-color: blueviolet; */
    /*height: 85vh; */
    /* height: 100%; */
    height: 87vh;
}
</style>

<script>
import SearchItem from './SearchItem'
export default {
    components: {
        SearchItem
    },

    data() {
        return {
            shouldShow: false,
            sortSelectedText: 'Recommended'
        }
    },
    methods: {
        onMouseOver(place) {
            console.log('onMouseOver')
            //console.log(place)
            this.$store.dispatch('place_setCurrentHoverId', place.id)
            // try to change class
            //this.$refs['marker-' + place.id].$el.classList.remove('numberCircle')
            //console.log(this.$refs)
            //console.log(this.$refs['marker-' + place.id])
            this.$root.$emit('increaseZIndex');

        },
        onMouseLeave() {
            console.log('onMouseLeave')
            //console.log(place)
            this.$root.$emit('decreaseZIndex');
            this.$store.dispatch('place_setCurrentHoverId', '')
            
        },
        clicked(place) {
            console.log('place is ' + place)
            console.log(place)
            this.$store.dispatch('sendEvidence', {
                content_id: place.id,
                event: 'item_clicked'
            })
            this.$router.push({
                name: 'Place',
                params: {
                    id: place.id
                }
            })
        },
        sortSelected(sort) {
            if (sort == 'recommended') {
                this.sortSelectedText = 'Recommended'
            } else if (sort == 'highest-rated') {
                this.sortSelectedText = 'Highest Rated'
            } else if (sort == 'most-reviewed') {
                this.sortSelectedText = 'Most Reviewed'
            }
        }
    },
    computed: {
        place_list: {
            get() {
                return this.$store.state.place_list
            }
        },
        place_totalRows: {
            get() {
                return this.$store.state.place_totalRows
            }
        },
        place_perPage: {
            get() {
                return this.$store.state.place_perPage
            }
        },
        place_currentPage: {
            get() {
                return this.$store.state.place_currentPage
            },
            set(newValue) {

                // scroll to first searchItem
                var name = 'searchItem-' + 0
                var container = (this.$refs[name])[0].$el
                this.$nextTick(() => {
                    container.scrollIntoView({ behavior: 'smooth' , block: 'start', inline: 'nearest'})
                })

                console.log('moving page to ' + newValue)
                this.$store.dispatch('place_setCurrentPage', newValue)
                if (this.place_current_resource == 'nearyou') {
                    this.$store.dispatch('retrievePlacesNearYou')
                } else if (this.place_current_resource == 'popular') {
                    this.$store.dispatch('retrievePlacesPopular')
                } else if (this.place_current_resource == 'foryou') {
                    this.$store.dispatch('retrievePlacesForYou')
                } else if (this.place_current_resource == 'search') {
                    var payload = {
                        text: this.$route.query.text,
                        location: this.$route.query.location
                    }
                    this.$store.dispatch('retrievePlacesSearch', payload)
                } else {
                    console.error('invalid selection')
                }
            }
        },
        place_current_resource: {
            get() {
                return this.$store.state.place_current_resource
            }
        },
        showPagination: {
            get() {
                return this.$store.state.place_totalRows > 0
            }
        },
        showLocationError: {
            get() {
                if (this.$store.state.gps_longitude == 0) {
                    return true
                } else {
                    return false
                }
            }
        },
        search_param: {
            get() {
                return this.$store.state.search_param
            }
        }
    },
    mounted() {
        console.log('mounted')
        console.log('mounted2')
        console.log('xxxxx')
        console.log(this.place_totalRows.length == 0)
    }
}
</script>